import { computed, inject, Injectable, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { OfficeFieldsValuesObj } from '../../models/office-data.model';
import { OfficeFormGroupsEnum, OfficeToolsFormGroup } from './models/office-tools-form.models';
import { OfficeStore } from '@pages/office/store/office.store';

@Injectable()
export class OfficeFormHelperService {
  public officeToolsForm: FormGroup<OfficeToolsFormGroup>;
  public validating$ = signal(false);
  public currentAnswer$ = computed(() => this.officeStore.getAnswerByKeyId(this.keyID));
  public keyID: number;

  private officeStore = inject(OfficeStore);

  public getKeyFieldsForm(): AbstractControl {
    return this.officeToolsForm.get([OfficeFormGroupsEnum.keyFields]);
  }

  public getEditFieldsForm(): AbstractControl {
    return this.officeToolsForm.get([OfficeFormGroupsEnum.editFields]);
  }

  public getOfficeToolsRawValue(): OfficeFieldsValuesObj {
    return {
      ...this.getKeyFieldsForm().getRawValue(),
      ...this.getEditFieldsForm().getRawValue(),
    };
  }

  public getControl(seq: number | string): AbstractControl {
    return this.getKeyFieldsForm().get([seq]) ?? this.getEditFieldsForm().get([seq]);
  }

  public getStringFormValue(value?: OfficeFieldsValuesObj): string {
    return JSON.stringify(value ?? this.getOfficeToolsRawValue());
  }
}
